import routes from '../routes/routes';
import { getLoggedStudent, isLoggedUser } from '../services/userService';
import history from './history';

export async function verifyLoggedUser() {
  try {
    const currentRoute = window.location.hash.toLowerCase();

    // Temporarily redirect everything to Coming Soon.
    // To make functional: uncomment this block and comment the original logic below.
    // if (!currentRoute.includes('/coming-soon')) {
    //   window.location.hash = '/coming-soon';
    //   window.location.reload();
    // }

    if (currentRoute.includes('/login')) {
      if (await isLoggedUser()) {
        history.replace('/app/dashboard');
      }
    } else {
      const noAppRoutes = [...routes.AUTH, ...routes.ROOT];
      if (!foundRoute(currentRoute, noAppRoutes)) {
        const user = await getLoggedStudent();
        const appRoutes = [...routes.APP, { path: '/question' }];
        if (
          !foundRoute(currentRoute, appRoutes) &&
          !(user.isForceUpdatePassword && user.resetPasswordToken)
        ) {
          history.replace('/app/dashboard');
        }
      }
    }
  } catch (err) {}
}

function foundRoute(searchedRoute, routes) {
  return routes.some((route) =>
    searchedRoute.includes(route.path.toLowerCase()),
  );
}
